// this file is automatically generated by git.revision.js script
export const versions = { revision: 'a559ddf779' }; 
 //expose the commit hash to the window object 
//@ts-ignore 
window.rd_version = 'a559ddf779';
